export const dlCartUpdateEvent = (cart) => {
    window.dataLayer.push({
        cart: {
            total_items: cart.total_items,
            total_price: cart.total_price,
            currency: cart.currency,
            products: cart.items
        }
    });
};
